import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/invoiceService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getEntrySubTypes } from "../../services/generalLedgerService";

class InvoiceForm extends Form {
  state = {
    imageUrl: false,
    invoiceDate: new Date(),
    data: {
      invoice_number: "",
      client: "",
      total_work_done: "",
      retention_percentage: "",
      //retention_amount:"",
      //total_amount:"",
      vat_percentage: "",
      reduction: "",
      project: "",
      //vat_amount:"",
      //grand_total:"",
    },
    projects: [],
    errors: {},
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    const params = {
      company: 1,
      entryType: "project",
    };
    const { data: res } = await getEntrySubTypes(params);
    this.setState({
      blocking: false,
      projects: res.accounts,
    });
  }

  schema = {
    id: Joi.string(),
    invoice_number: Joi.string().required().label("Invoice #"),
    client: Joi.string().required().label("Client"),
    total_work_done: Joi.number().required().label("Total Work Done"),
    retention_percentage: Joi.number().required().label("Retention Percentage"),
    // retention_amount: Joi.number()
    // .required()
    // .label("Retention Amount"),
    // total_amount: Joi.number()
    // .required()
    // .label("Retention Amount"),
    vat_percentage: Joi.number().required().label("VAT Percentage"),
    reduction: Joi.number().label("Deduction"),
    project: Joi.number().required(),
    // .label("VAT Amount"),
    // grand_total: Joi.number()
    // .required()
    // .label("Grand Total")
  };

  handleChangeInvoice = (date) => {
    this.setState({
      invoiceDate: date,
    });
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      let formData = new FormData();

      var event = new Date(this.state.invoiceDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("invoice_date", date);

      formData.append("invoice_number", this.state.data.invoice_number);
      formData.append("client", this.state.data.client);
      formData.append("total_work_done", this.state.data.total_work_done);
      formData.append(
        "retention_percentage",
        this.state.data.retention_percentage
      );
      //formData.append("retention_amount",this.state.data.retention_amount);
      //formData.append("total_amount",this.state.data.total_amount);
      formData.append("vat_percentage", this.state.data.vat_percentage);
      //formData.append("vat_amount",this.state.data.vat_amount);
      formData.append("grand_total", this.state.data.grand_total);
      formData.append("reduction", this.state.data.reduction);
      formData.append("attachment", this.state.imageUrl);
      formData.append("project_id", this.state.data.project);

      await saveSingle(formData);
      toast.success("Invoice has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/invoices");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.passport_number)
          errors.passport_number = ex.response.data.errors.passport_number;

        if (ex.response.data.errors.identification_id)
          errors.identification_id = ex.response.data.errors.identification_id;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add invoice</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/invoices")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add invoice</h3>
              <p>Provide the information below to add the invoice.</p>
              <label>Date</label>

              <DatePicker
                selected={this.state.invoiceDate}
                onChange={this.handleChangeInvoice}
                className="input"
              />
              {this.renderInput("invoice_number", "Invoice Number", "text")}
              {this.renderInput("client", "Client", "text")}
              {this.renderInput("total_work_done", "Total Work Done", "text")}
              {this.renderInput("retention_percentage", "Retention %", "text")}
              {this.renderInput("reduction", "Deduction", "text")}
              {this.renderInput("vat_percentage", "Vat %", "text")}
              <label>Attachment</label>
              <input
                className="input"
                type="file"
                onChange={this.onChangeFile}
              />
              {this.renderSelect("project", "Project", this.state.projects)}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default InvoiceForm;
